<script lang="ts">
	import { page } from '$app/state';
	import NotificationProvider from '$lib/components/notification/store.svelte';
	import ActitoProvider from '$lib/components/third-parties/actito/store.svelte';
	import AwinProvider from '$lib/components/third-parties/awin/store.svelte';
	import CriteoProvider from '$lib/components/third-parties/criteo/store.svelte';
	import GoogleAdsProvider from '$lib/components/third-parties/google/ads/store.svelte';
	import GoogleAnalyticsProvider from '$lib/components/third-parties/google/analytics/store.svelte';
	import KwankoProvider from '$lib/components/third-parties/kwanko/store.svelte';
	import MetaAdsProvider from '$lib/components/third-parties/meta-ads/store.svelte';
	import PinterestProvider from '$lib/components/third-parties/pinterest/store.svelte';
	import TikTokAdsProvider from '$lib/components/third-parties/tiktok-ads/store.svelte';
	import { setContext, type Snippet } from 'svelte';

	import AuthProvider from './auth/store.svelte';
	import CartProvider from './cart/store.svelte';

	let { children }: { children: Snippet } = $props();

	const notificationProvider = new NotificationProvider();
	const authProvider = new AuthProvider();
	const cartProvider = new CartProvider(
		authProvider,
		notificationProvider,
		page.data.store.store_id,
		page.data.store.locale,
	);

	setContext('notification', notificationProvider);
	setContext('auth', authProvider);
	setContext('cart', cartProvider);

	const {
		actito,
		google_ads,
		google_analytics,
		meta_pixel,
		kwanko,
		criteo,
		tiktok_ads,
		pinterest,
		awin,
	} = page.data.store.third_parties ?? {};

	if (actito) {
		setContext('actito', new ActitoProvider(actito, page.data.store.store_name));
	}
	if (google_ads) {
		setContext(
			'googleAds',
			new GoogleAdsProvider(google_ads, page.data.store.currency, authProvider),
		);
	}
	if (google_analytics) {
		setContext('googleAnalytics', new GoogleAnalyticsProvider(page.data.store.currency));
	}
	if (meta_pixel) {
		setContext('metaAds', new MetaAdsProvider(page.data.store.currency));
	}
	if (kwanko) {
		setContext('kwanko', new KwankoProvider(kwanko.mclic, page.data.store.currency));
	}
	if (criteo) {
		setContext(
			'criteo',
			new CriteoProvider(
				criteo.account_id,
				page.data.store.store_id,
				page.data.store.store_name,
				authProvider,
			),
		);
	}
	if (tiktok_ads) {
		setContext(
			'tiktokAds',
			new TikTokAdsProvider(
				page.data.store,
				page.data.clientIp,
				page.data.clientUserAgent,
				authProvider,
			),
		);
	}
	if (pinterest) {
		setContext('pinterest', new PinterestProvider(page.data.store.currency, authProvider));
	}
	if (awin) {
		setContext('awin', new AwinProvider(awin.id));
	}
</script>

{@render children()}
